import React from "react";
import "./Question.css";

const Question = () => {
  return (
    <div>
      <div className="question mx-md-5 px-md-4 px-0 mx-2">
        <span className="fw-bold mb-4 fs-5">
          1) Question: How does works React?
        </span>
        <div className="card">
          <p>
            React uses a declarative paradigm that makes it easier to reason
            about your application and aims to be both efficient and flexible.
            It designs simple views for each state in your application, and
            React will efficiently update and render just the right component
            when your data changes.
          </p>
        </div>
        <br></br>
        <span className="fw-bold mb-3 fs-5">
          2) Question: Difference between Props and State?
        </span>
        <div className="card">
          <p>
            <div className="d-flex props-state">
              <ul>
                <p className="text-center fw-bold">Props</p>
                <li>1. The Data is passed from one component to another.</li>
                <li>2. It is Immutable (cannot be modified).</li>
                <li>3. Props are read-only.</li>
              </ul>

              <ul>
                <p className="text-center fw-bold">State</p>
                <li>1. The Data is passed within the component only.</li>
                <li>2. It is Mutable ( can be modified).</li>
                <li>3. State is both read and write.</li>
              </ul>
            </div>
          </p>
        </div>
        <br />
        <span className="fw-bold mb-3 fs-5">
          3) Question: What is the use of useEffect without data loading ?
        </span>
        <div className="card">
          <p>
            <ul>
              <li>1. Running on state change: validating input field</li>
              <li>2. Running on state change: live filtering</li>
              <li>
                3. Running on state change: trigger animation on new array value
              </li>
            </ul>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Question;
